<template>
    <main id="community_main" class="page" role="main">
        <community-header></community-header>
        <router-view></router-view>
        <modal></modal>
    </main>
</template>

<script>
import CommunityHeader from "./CommunityHeader";
import Modal from "../Modal.vue";

export default {
    components: {
        CommunityHeader,
        Modal
    }
}
</script>
